import EditIcon from 'Assets/Icons/edit-icon.svg';
export const CustomInputBox = ({
  formik,
  mobile,
  label,
  value: propValue, // Renamed to avoid confusion with controlled value
  placeholder,
  disabled,
  type,
  showLabel,
  maxLength
}) => {
  // Handle input change to trim leading spaces
  const handleChange = (e) => {
    const trimmedValue = e.target.value.trimStart(); // Remove leading spaces
    formik.setFieldValue(label, trimmedValue); // Update Formik's field value
  };

  return (
    <>
      <div className="input-group">
        {showLabel && <label>{placeholder}</label>}
        <input
          autoComplete="off"
          placeholder={placeholder}
          type={type ? type : 'text'}
          disabled={disabled}
          value={formik?.values[label] || propValue || ''} // Use Formik's value or fallback
          {...formik?.getFieldProps(label)} // Spread Formik props (onBlur, etc.)
          onChange={handleChange} // Override onChange to trim leading spaces
          maxLength={maxLength}
        />
        <p className="">
          {formik?.touched[label] &&
            formik?.errors[label] &&
            formik?.errors[label]}
        </p>
      </div>
    </>
  );
};
export const EmailInput = ({
  formik,
  mobile,
  label,
  value,
  placeholder,
  disabled,
  type,
  showLabel
}) => {
  return (
    <>
      <div className="input-group">
        {showLabel && <label>{placeholder}</label>}
        <input
          autoComplete="off"
          placeholder={placeholder}
          type={type ? type : 'text'}
          disabled={disabled}
          value={value}
          {...formik?.getFieldProps(label)}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, ''); // Remove numbers
          }}
        />
        <p className="">
          {formik?.touched[label] &&
            formik?.errors[label] &&
            formik?.errors[label]}
        </p>
      </div>
    </>
  );
};
export const CustomInputBoxWithEditIcon = ({ value, onClick }) => {
  return (
    <>
      <div className="input-group">
        <div className="edit-icon-input-box">
          <div>{value}</div>
          <img
            onClick={onClick}
            src={EditIcon}
            alt="Edit Icon"
            className="edit-icon"
          />
        </div>
      </div>
    </>
  );
};
